export const CUSTOMER_EXISTS_ERROR_MSG =
  'This email is already associated with an account.';
export const ONE_SCREENING_PER_EMAIL_ERROR_MSG =
  'Email has already been used for a free screening.';
